export const BREAKPOINTS = {
   SMALL:  576,
   MEDIUM: 768,
   LARGE:  992,
   XLARGE: 1440
};
